<template>

  <!-- cabecera con selector de empresa -->
  <div class="text-xs-center" v-if="muestraSeleccionEmpresa">
    <v-menu offset-x :close-on-content-click="false" :nudge-width="100" v-model="despliegaSeleccionEmpresa" bottom left>
      <v-avatar class="grey data-cpointer" slot="activator">
        <v-icon dark>business</v-icon>
      </v-avatar>
      <v-card class="data-selectorEmpresa">
        <v-list class="data-list">
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <v-avatar class="grey">
                <v-icon dark>business</v-icon>
              </v-avatar>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="data-colorcorp1 data-fbold700">{{ this.nombreEmpresa }}</v-list-tile-title>
              <v-list-tile-sub-title class="caption">{{ loggedUser }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
          <v-container class="scroll-y" id="scroll-target">
            <template v-for="(empresa) in listaEmpresas">
              <v-radio-group class="data-radioButton" v-model="empresaSeleccionada" :key="empresa.key">
                <v-list-tile>
                  <v-list-tile-action>
                    <v-radio :value="empresa.empresa"></v-radio>
                  </v-list-tile-action>
                  <v-list-tile-title class="body-1" v-html="empresa.nombre"></v-list-tile-title>
                </v-list-tile>
              </v-radio-group>
            </template>
          </v-container>
        </v-list>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat class="data-colorcorp2" @click="menu = false; empresaSeleccionada = ''">{{ this.$t('cancelar') }}</v-btn>
          <v-btn class="data-colorcorp1" flat @click="seleccionaEmpresa(); menu = false">{{ this.$t('aceptar') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>

</template>

<script>

import SrvGeneral from '@/services/srv-general'

export default {
  name: 'ShpSeleccionEmpresa',
  components: {
  },
  props: {
    moduloApp: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      modulo: this.$store.getters.getModulo,
      muestraSeleccionEmpresa: this.modulo === 'PRESUPUESTOS',
      despliegaSeleccionEmpresa: false,
      empresaSeleccionada: '',
      dEventoAlerta: 'evento-mostrarAvisos',
      listaEmpresas: []
    }
  },
  watch: {
    moduloApp: {
      handler() {
        this.modulo = this.$store.getters.getModulo
        this.muestraSeleccionEmpresa = (this.modulo === 'PRESUPUESTOS')
      }
    }
  },
  created() {
    // Actualiza opciones de visualizacion
    this.muestraSeleccionEmpresa = (this.modulo === 'PRESUPUESTOS')
    // 
    if (this.loggedUser !== null) {
      this.cargaEmpresas()
    }
  },
  beforeDestroy() {
  },
  methods: {
    /*
     * Evento para lanzar la carga de datos
     */
    cargaEmpresas() {
      const sortBy = 'nombre'
      const descending = 'ASC'

      // prepara los parametros generales de busqueda
      const jsonEntrada = {
        orderBy: sortBy,
        order: descending
      }
      SrvGeneral.lovEmpresa(jsonEntrada).then(response => {
        if (response.data.statusCode === '200') {
          const arrayEmpresaTemp = response.data.dataRes
          if (arrayEmpresaTemp != null) {
            for (let i = 0; i < arrayEmpresaTemp.length; i++) {
              const empresaTemp = arrayEmpresaTemp[i]
              if (empresaTemp.empresa !== this.$store.getters.getAutenticacion.empresa) {
                this.listaEmpresas.push(empresaTemp)
              }
            }
          }
        } else {
          this.$bus.$emit(this.dEventoAlerta, '<b>carga las empresas</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
      }).catch(error => {
        this.$bus.$emit(this.dEventoAlerta, '<b>carga las empresas</b><br> ' + error.response.data.statusText)
      })
    },
    /**
     * Cambia la empresa
     */
    seleccionaEmpresa() {
      const datosAutenticacion = this.$store.getters.getAutenticacion
      datosAutenticacion.empresa = this.empresaSeleccionada
      datosAutenticacion.nombreEmpresa = this.getNombreEmpresa(datosAutenticacion.empresa)
      // Establecemos el token para las siguientes llamadas con axios.
      localStorage.setItem('datos-autenticacion', JSON.stringify(datosAutenticacion))
      // Entra en la aplicacion
      window.document.location.reload()
    },
    /**
     * obtiene el nombre de una agrupacion
     */
    getNombreEmpresa(empresaCodigo) {
      if (this.listaEmpresas !== null) {
        for (let i = 0; i < this.listaEmpresas.length; i++) {
          const empresa = this.listaEmpresas[i]
          if (empresa.empresa === empresaCodigo) {
            return empresa.nombre
          }
        }
      }
      return this.$t('')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Informes/Base/ShpSeleccionEmpresa.vue